<template>
  <div class="AutoColdOfferVehicleQuestionsFormInteractive">
    <InteractiveForm
      ref="rfAutoColdOfferVehicleQuestionsFormInteractive"
      :steps="cptdSequenceDisplayKeys"
      :busy="busy"
      current-form="vehicle-questions"
      :auto-selectable-steps="autoSelectableSteps"
      @submit="submit"
    >
      <template #default="{ step, validation }">
        <PlateInput
          v-if="displayInput(step, 'plate')"
          id="auto_plate"
          key="plate"
          v-model="vehicleQuestions.plate"
          label="Qual é a placa do veículo?"
          name="auto_plate"
          :validation="validation"
        />
        <PlateInput
          v-if="displayInput(step, 'plate_confirm')"
          id="auto_plate_confirm"
          key="auto_plate_confirm"
          v-model="plateConfirm"
          label="Confirme a placa do veículo"
          name="auto_plate_confirm"
          :validation="validation"
          :validations="`required|min:8|carPlate|confirm-insensitive:${vehicleQuestions.plate}`"
        />
        <RadioInputList
          v-if="displayInput(step, 'type')"
          id="autoTypesRadioList"
          key="autoTypesRadioList"
          v-model="vehicleQuestions.type"
          title="Qual é o tipo do veículo?"
          :options="cptdAutoTypesList"
          :searchable="false"
          :validation="validation"
          @input="autoSelectField('type', $event)"
        />
        <AutoModelYearRadioList
          v-if="displayInput(step, 'model_year')"
          id="AutoModelYearRadioList"
          key="AutoModelYearRadioList"
          v-model="vehicleQuestions.model_year"
          :validation="validation"
          @input="autoSelectField('model_year', $event)"
        />
        <AutoManufacturerYearsRadioList
          v-if="displayInput(step, 'year')"
          id="AutoManufacturerYearsRadioList"
          key="AutoManufacturerYearsRadioList"
          v-model="vehicleQuestions.year"
          :model-year="vehicleQuestions.model_year"
          :validation="validation"
          @input="autoSelectField('year', $event)"
        />
        <StateRadioList
          v-if="displayInput(step, 'licensed_state')"
          id="licensed_state"
          key="licensed_state"
          v-model="vehicleQuestions.licensed_state"
          title="Selecione o Estado de licenciamento do veículo"
          :validation="validation"
          @input="autoSelectField('licensed_state', $event)"
        />

        <YesOrNoCheckInput
          v-if="displayInput(step, 'vehicle_owner')"
          id="vehicle_owner"
          key="vehicle_owner"
          v-model="vehicleQuestions.vehicle_owner"
          name="vehicle_owner"
          label="O veículo está em seu nome?"
          :validation="validation"
          @input="autoSelectField('vehicle_owner', $event)"
        />
        <YesOrNoCheckInput
          v-if="displayInput(step, 'vehicle_debt')"
          id="vehicle_debt"
          key="vehicle_debt"
          v-model="vehicleQuestions.vehicle_debt"
          name="vehicle_debt"
          label="O veículo está quitado?"
          :validation="validation"
          :inverse="true"
          @input="autoSelectField('vehicle_debt', $event)"
        />
        <YesOrNoCheckInput
          v-if="displayInput(step, 'vehicle_debt_over_eighty_percent')"
          id="vehicle_debt_over_eighty_percent"
          key="vehicle_debt_over_eighty_percent"
          v-model="vehicleQuestions.vehicle_debt_over_eighty_percent"
          name="vehicle_debt_over_eighty_percent"
          label="O valor restante para quitar é menor ou igual a 80% do valor do veículo?"
          helper-message="É a somatória de todas as parcelas que ainda restam para pagar."
          :validation="validation"
          @input="autoSelectField('vehicle_debt_over_eighty_percent', $event)"
        />
        <YesOrNoCheckInput
          v-if="displayInput(step, 'vehicle_is_auctioned')"
          id="vehicle_is_auctioned"
          key="vehicle_is_auctioned"
          v-model="vehicleQuestions.vehicle_is_auctioned"
          name="vehicle_is_auctioned"
          label="O veículo é de leilão?"
          :validation="validation"
          @input="autoSelectField('vehicle_is_auctioned', $event)"
        />
        <YesOrNoCheckInput
          v-if="displayInput(step, 'vehicle_is_taxi')"
          id="vehicle_is_taxi"
          key="vehicle_is_taxi"
          v-model="vehicleQuestions.vehicle_is_taxi"
          name="vehicle_is_taxi"
          label="O veículo é um taxi?"
          :validation="validation"
          @input="autoSelectField('vehicle_is_taxi', $event)"
        />
        <YesOrNoCheckInput
          v-if="displayInput(step, 'vehicle_is_adapted')"
          id="vehicle_is_adapted"
          key="vehicle_is_adapted"
          v-model="vehicleQuestions.vehicle_is_adapted"
          name="vehicle_is_adapted"
          label="O veículo é adaptado?"
          :validation="validation"
          @input="autoSelectField('vehicle_is_adapted', $event)"
        />
        <YesOrNoCheckInput
          v-if="displayInput(step, 'traffic_ticket')"
          id="traffic_ticket"
          key="traffic_ticket"
          v-model="vehicleQuestions.traffic_ticket"
          name="traffic_ticket"
          label="O veículo está regularizado?"
          helper-message="Com os documentos em dia e sem nenhuma multa aberta."
          :inverse="true"
          :validation="validation"
          @input="autoSelectField('traffic_ticket', $event)"
        />
      </template>
    </InteractiveForm>
  </div>
</template>
<script>
import { nextTick } from 'vue'
import InteractiveForm from '@/components/forms/InteractiveForm.vue'

import { AutoType } from '@/data/common'
import StateRadioList from '@/components/forms/fields/radioInputList/StateRadioList.vue'
import AutoManufacturerYearsRadioList from '@/components/forms/fields/radioInputList/AutoManufacturerYearsRadioList.vue'
import AutoModelYearRadioList from '@/components/forms/fields/radioInputList/AutoModelYearRadioList.vue'
import RadioInputList from '@/components/ui/newComponents/RadioInputList.vue'
import YesOrNoCheckInput from '@/components/forms/fields/checkInput/YesOrNoCheckInput.vue'
import PlateInput from '@/components/forms/fields/input/PlateInput.vue'
export default {
  name: 'AutoColdOfferVehicleQuestionsFormInteractive',
  components: {
    PlateInput,
    StateRadioList,
    AutoManufacturerYearsRadioList,
    AutoModelYearRadioList,
    RadioInputList,
    InteractiveForm,
    YesOrNoCheckInput,
  },
  props: {
    busy: { type: Boolean, default: false },
    lblButtonSubmit: { type: String, default: 'Continuar' },
  },
  emits: ['submit'],
  data() {
    return {
      plateConfirm: '',
      vehicleQuestions: {
        plate: '',
        type: '',
        model_year: '',
        vehicle_owner: null,
        vehicle_debt: null,
        vehicle_debt_over_eighty_percent: null,
        vehicle_is_taxi: null,
        vehicle_is_adapted: null,
        vehicle_is_auctioned: null,
        traffic_ticket: null,
        licensed_state: '',
        year: '',
      },
      autoSelectableSteps: [
        'type',
        'model_year',
        'year',
        'vehicle_owner',
        'vehicle_debt',
        'traffic_ticket',
        'vehicle_debt_over_eighty_percent',
        'vehicle_is_auctioned',
        'vehicle_is_taxi',
        'vehicle_is_adapted',
        'licensed_state',
      ],
    }
  },
  computed: {
    cptdSequenceDisplayKeys() {
      if (this.vehicleQuestions.vehicle_debt) {
        return [
          'plate',
          'type',
          'licensed_state',
          'model_year',
          'year',
          'vehicle_owner',
          'vehicle_debt',
          'traffic_ticket',
          'vehicle_debt_over_eighty_percent',
          'vehicle_is_auctioned',
          'vehicle_is_taxi',
          'vehicle_is_adapted',
        ]
      }
      return [
        'plate',
        'plate_confirm',
        'type',
        'licensed_state',
        'model_year',
        'year',
        'vehicle_owner',
        'vehicle_debt',
        'traffic_ticket',
        'vehicle_is_auctioned',
        'vehicle_is_taxi',
        'vehicle_is_adapted',
      ]
    },
    cptdAutoTypesList() {
      return [
        {
          label: 'Automóvel',
          id: AutoType.CAR,
          value: AutoType.CAR,
        },
        {
          label: 'Motocicleta',
          id: AutoType.MOTORCYCLE,
          value: AutoType.MOTORCYCLE,
        },
        {
          label: 'Caminhão',
          id: AutoType.TRUCK,
          value: AutoType.TRUCK,
        },
      ]
    },
  },
  methods: {
    autoSelectField(key, value) {
      this.vehicleQuestions[key] = value
      nextTick(() => {
        this.$refs.rfAutoColdOfferVehicleQuestionsFormInteractive.next()
      })
    },
    displayInput(step, key) {
      return step === key
    },
    submit() {
      this.$emit('submit', {
        ...this.vehicleQuestions,
        plate: this.vehicleQuestions.plate.replace('-', ''),
      })
    },
  },
}
</script>
<style lang="scss"></style>
